"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _mobxReact = require("mobx-react");

var _types = require("../../util/types");

function UrlChooser(props) {
  var location = props.location,
      setLocation = props.setLocation,
      label = props.label;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    fullWidth: true,
    variant: "outlined",
    inputProps: {
      'data-testid': 'urlInput'
    },
    defaultValue: location && (0, _types.isUriLocation)(location) ? location.uri : '',
    label: label || 'Enter URL',
    onChange: function onChange(event) {
      setLocation({
        uri: event.target.value.trim(),
        locationType: 'UriLocation'
      });
    }
  }));
}

var _default = (0, _mobxReact.observer)(UrlChooser);

exports.default = _default;